import React, { useEffect } from 'react';

const Logout = (props) => {

  useEffect(() => {
    props.handleLogout()
  })
  return <div></div>
}

export default Logout;